import './Component2.css'
import React from 'react'

const Component2 = () => {
  return (
    <div className='main-2-div'>
        <h1 className='h1-2'>COMPONENT - 2</h1>
    </div>
  )
}

export default Component2
